import { formatNumber } from '@/lib/utils';

export interface HorizontalBarData {
  label: string;
  value: number;
  hint?: string;
}

interface Props {
  data: HorizontalBarData[];
  formatter?: (v: number) => string;
}

export function HorizontalBar({ data, formatter = formatNumber }: Props) {
  const max = Math.max(1, ...data.map((d) => d.value));
  const total = data.reduce((s, d) => s + d.value, 0) || 1;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      {data.map((d, i) => {
        const pct = (d.value / max) * 100;
        const share = (d.value / total) * 100;
        return (
          <div key={i} style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                gap: 8,
                fontSize: 12,
              }}
            >
              <span style={{ color: 'var(--bx-text-dark)', fontWeight: 500 }}>{d.label}</span>
              <span
                style={{
                  fontFamily: 'var(--bx-font-mono)',
                  fontVariantNumeric: 'tabular-nums',
                  color: 'var(--bx-text-dark)',
                  fontWeight: 600,
                }}
              >
                {formatter(d.value)}{' '}
                <span style={{ color: 'var(--bx-text-muted)', fontWeight: 400 }}>
                  ({share.toFixed(1)}%)
                </span>
              </span>
            </div>
            <div
              style={{
                height: 8,
                background: 'var(--bx-surface-2)',
                borderRadius: 9999,
                overflow: 'hidden',
              }}
            >
              <div
                style={{
                  height: '100%',
                  width: `${pct}%`,
                  background: 'linear-gradient(90deg, var(--bx-primary), #6366f1)',
                  borderRadius: 9999,
                  transition: 'width 200ms var(--bx-ease)',
                }}
              />
            </div>
            {d.hint && (
              <div style={{ fontSize: 10.5, color: 'var(--bx-text-muted)' }}>{d.hint}</div>
            )}
          </div>
        );
      })}
    </div>
  );
}
